"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _globalStyledComponents = require("../../globalStyledComponents");

var Root = _styledComponents["default"].div.withConfig({
  displayName: "styles__Root",
  componentId: "w2rjo9-0"
})(["", " width:100vw;overflow-x:", ";.filters-container{display:flex;align-items:center;width:100%;margin:", ";.active-category{display:flex;align-items:center;margin-right:3rem;img{border-radius:0.5rem;border:1px solid #dedfe2;height:2.5rem;width:2.5rem;object-fit:contain;margin-right:1rem;padding:0.25rem;background-color:#ffffff;}.name-title-container{display:flex;flex-direction:column;p{color:#3963fe;font-size:0.75rem;letter-spacing:0.25px;line-height:1rem;cursor:pointer;&:hover{opacity:0.8;}}}}.filter{display:flex;align-items:center;cursor:pointer;font-size:0.75rem;font-weight:bold;line-height:1rem;height:2rem;letter-spacing:0.25px;background-color:#ffffff;box-shadow:0px 0px 2px 0px rgba(0,0,0,0.14),0px 2px 2px 0px rgba(0,0,0,0.12),0px 1px 3px 0px rgba(0,0,0,0.2);border-radius:0.5rem;padding:0.25rem 0.5rem;margin-right:0.5rem;img{height:2rem;width:2rem;object-fit:contain;margin-right:0.25rem;}&.active{box-shadow:none;border:", ";}}}.filter-features-row{flex-direction:", ";margin:", ";.availability-container{display:flex;}.availability-switch{}.search-filter{margin-right:1rem;}.zip-container{display:flex;flex-direction:column;justify-content:center;min-width:9.25rem;margin-left:0.75rem;margin-right:", ";.zip-toggle{display:flex;align-items:center;span{color:#3963fe;cursor:pointer;&:hover{opacity:0.8;}}i{color:#3963fe;cursor:pointer;font-size:0.75rem;margin-left:0.25rem;}}}}.zip-input-container{margin:", ";}.location-input{height:0px;z-index:99;margin:", ";width:", ";input{margin-right:", ";box-shadow:0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12),0px 3px 5px 0px rgba(0,0,0,0.2);&:focus{box-shadow:0px 0px 4px 0px #3963fe;}}i{margin-right:", ";}.no-display{display:none;}.fa-map-marker-alt{cursor:pointer;font-weight:700;}.fa-spinner{height:fit-content;width:fit-content;animation-name:spin;animation-duration:1s;animation-iteration-count:infinite;animation-timing-function:linear;}@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}}.header-container{justify-content:space-between;align-items:center;margin-top:", ";}.clear-filters-btn{background:none;text-transform:none;font-size:12px;font-weight:bold;height:16px;letter-spacing:0.5px;line-height:16px;color:#3963fe;margin:auto 0;width:fit-content;padding:0;&:hover{opacity:0.9;text-decoration:underline;}}"], _globalStyledComponents.RootCSS, function (_ref) {
  var mobile = _ref.mobile;
  return mobile && 'hidden';
}, function (_ref2) {
  var mobile = _ref2.mobile;
  return mobile ? '1rem' : '1.5rem 0';
}, function (_ref3) {
  var mobile = _ref3.mobile;
  return mobile && 'solid 1px #f4f5f6';
}, function (_ref4) {
  var mobile = _ref4.mobile;
  return mobile && 'column';
}, function (_ref5) {
  var mobile = _ref5.mobile;
  return mobile ? '0 1rem 1rem' : '';
}, function (_ref6) {
  var mobile = _ref6.mobile;
  return mobile ? '2rem' : '1.5rem';
}, function (_ref7) {
  var mobile = _ref7.mobile;
  return !mobile && '0 0 2.75rem';
}, function (_ref8) {
  var mobile = _ref8.mobile;
  return mobile ? '0.5rem 0 0' : '0 0 0 3.5rem';
}, function (_ref9) {
  var mobile = _ref9.mobile;
  return mobile ? '100%' : '10rem';
}, function (_ref10) {
  var mobile = _ref10.mobile;
  return mobile && '2rem';
}, function (_ref11) {
  var mobile = _ref11.mobile;
  return mobile && '3rem';
}, function (_ref12) {
  var mobile = _ref12.mobile;
  return mobile && '2rem';
});

var ItemsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ItemsContainer",
  componentId: "w2rjo9-1"
})(["display:flex;flex-direction:column;justify-content:space-between;", " h3{margin:", ";font-size:", ";}.supplier-row{h5{margin:", ";align-items:center;justify-content:center;}", "}.card,.loading-card{margin:1.5rem 1rem 0 0;}.loading-card:first-child{margin-left:", ";}.card{height:fit-content;letter-spacing:0;text-decoration:none;&:nth-last-child(2){margin-right:", ";}&:first-child{margin-left:", ";}&:last-child{padding-right:", ";}", "}.arrow{align-self:center;color:#969ba5;font-size:2rem;font-weight:300;height:2.5rem;line-height:2.5rem;text-align:center;width:2.5rem;cursor:pointer;&.right{margin-left:0.5rem;}&.left{margin-right:0.5rem;}&:hover{opacity:0.7;}}.loader{align-self:center;}.supplier-column{height:fit-content;.cards-container{min-height:5rem;overflow-x:", ";.no-products{margin:auto;width:100vw;}&.loading{margin:", ";}}}"], function (_ref13) {
  var mobile = _ref13.mobile;
  return mobile && (0, _styledComponents.css)(["h1{font-size:1rem;}margin-left:1rem;"]);
}, function (_ref14) {
  var mobile = _ref14.mobile;
  return mobile ? '2rem 2rem 0' : '2rem 10rem 0';
}, function (_ref15) {
  var mobile = _ref15.mobile;
  return mobile && '0.75rem';
}, function (_ref16) {
  var mobile = _ref16.mobile;
  return mobile ? '3rem 0 3rem 5rem;' : '5rem 0 5rem 5rem';
}, function (_ref17) {
  var mobile = _ref17.mobile;
  return mobile && 'margin-bottom: 2rem;';
}, function (_ref18) {
  var mobile = _ref18.mobile;
  return mobile ? '1rem' : '3rem';
}, function (_ref19) {
  var mobile = _ref19.mobile;
  return mobile ? '' : 0;
}, function (_ref20) {
  var mobile = _ref20.mobile;
  return mobile && '1rem';
}, function (_ref21) {
  var mobile = _ref21.mobile;
  return mobile && '1rem';
}, function (_ref22) {
  var mobile = _ref22.mobile;
  return mobile && 'margin: 1rem 1rem 0 0;';
}, function (_ref23) {
  var mobile = _ref23.mobile;
  return mobile && 'auto';
}, function (_ref24) {
  var mobile = _ref24.mobile;
  return mobile ? '0 0 0 -1rem' : '0 0 3rem';
});

var MobileSearchContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__MobileSearchContainer",
  componentId: "w2rjo9-2"
})(["display:flex;padding:1rem 1rem 0.5rem;position:fixed;bottom:0;left:0;right:0;z-index:99;background-color:rgba(244,245,246,0.85);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);@supports (padding-bottom:constant(safe-area-inset-bottom)){--safe-area-inset-bottom:constant(safe-area-inset-bottom);margin-bottom:var(--safe-area-inset-bottom);}@supports (padding-bottom:env(safe-area-inset-bottom)){--safe-area-inset-bottom:env(safe-area-inset-bottom);margin-bottom:var(--safe-area-inset-bottom);}.search-container{width:100%;.search-input{width:100%;}.zip-input{width:5rem;}}.search-column{width:100%;}"]);

var FixedHeader = _styledComponents["default"].div.withConfig({
  displayName: "styles__FixedHeader",
  componentId: "w2rjo9-3"
})(["display:flex;flex-direction:column;padding:2rem 1rem 1rem;background-color:rgba(244,245,246);z-index:99;min-height:7rem;"]);

var _default = {
  Root: Root,
  Row: _globalStyledComponents.Row,
  ItemsContainer: ItemsContainer,
  Column: _globalStyledComponents.Column,
  MobileSearchContainer: MobileSearchContainer,
  FixedHeader: FixedHeader
};
exports["default"] = _default;